module.exports = __webpack_public_path__ + "img/news.b67e27cb.svg";